const server = process.env.REACT_APP_SERVER;

async function getOrdenProduccion(parametros){
    var respuesta = await fetch(`${server}/reporte/OrdenProduccion`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...parametros
        })
    })
    return respuesta.json()
}
async function editarProyeccionSemanal(params) {
    var respuesta = await fetch(`${server}/reporte/EditarProyeccionSemanal`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return respuesta.json()
}
export default {getOrdenProduccion,editarProyeccionSemanal}